import React from 'react';
import styled from 'styled-components';
import { layout } from '../../../config/styles';
import { Icon } from 'semantic-ui-react';
import { ReflexContainer, ReflexSplitter, ReflexElement } from 'react-reflex';

export const StyledReflexContainer = styled(ReflexContainer)``;

export const ContainerLeft = styled.div`
  float: left;
  width: 60px;
  height: calc(100vh - ${layout.headerHeight}px);
  background-color: #f2f5fc;
`;

export const Users = styled(ReflexElement)`
  margin-bottom: 6px;
`;

export const ResizeHandle = styled(ReflexSplitter)`
  &&& {
    height: 2px;
    border-radius: 3px;
    background-color: #8a94bd !important;
    border: none !important;
    width: 20px;
    margin: 0 auto -16px auto;
    transition: none !important;
    z-index: 10;
    opacity: 0.8;
  }
`;

export const UserChatSettingsContainer = styled(ReflexElement)`
  background: transparent;
  padding-top: 8px;
  overflow: hidden !important;
`;

export const UserChatSettings = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 16px;
  height: 100%;
  background: #f2f5fc;
  border-radius: 8px;
  box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.05);
  margin: 0 auto;
  min-height: 100px;
`;

export const SettingContainer = styled(({ isSelected, ...props }) => (
  <div {...props} />
))`
  border: ${({ isSelected }: any) => (isSelected ? '4px solid white' : 'none')};
  box-shadow: ${({ isSelected }: any) =>
    isSelected ? '0 0 10px 0 rgba(0, 0, 0, 0.3)' : ''};
  margin: ${({ isSelected }: any) => (isSelected ? '4px' : '8px')};
  width: ${({ isSelected }: any) => (isSelected ? '40px' : '32px')};
  height: ${({ isSelected }: any) => (isSelected ? '40px' : '32px')};
  opacity: ${({ isSelected }: any) => (isSelected ? '1' : '0.8')};
  border-radius: 50%;
  background-color: #8a94bd;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  min-height: 32px;
  opacity: 0.8;
  > i.icon {
    line-height: 1;
    font-size: 14px;
    margin: 0 !important;
    color: #fff;
    transition: color 500ms ease;
  }
`;

export { Icon };
